// extracted by mini-css-extract-plugin
module.exports = {"container":"subscribed-success_container__1K3sJ","payment":"subscribed-success_payment__2OCyR","card":"subscribed-success_card__c2Kk-","note":"subscribed-success_note__3t0xQ"};